import { NewLeadsMap } from "./NewLeadsAction";

const initialState = {
  isLoading: false,
  coldLeadsList: {},
  refreshColdLeadsList: true,
  searchBy: "",
  searchText: "",
  skip: 0,
  limit: 50,
  selectedColdLead: {},
  audioType: "all",
  batchFilter: "",
  dateFilter: "",
  fromDateFilter: "",
  toDateFilter: "",
  leadType: "all",
  callOutcomeFilter: "all",
  companyNameFilter: "all",
  createdByFilter: "",
  batchNames: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case NewLeadsMap.GET_ALL_NEW_LEADS_START:
      return {
        ...state,
        isLoading: true,
      };
    case NewLeadsMap.GET_ALL_NEW_LEADS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coldLeadsList: action.payload,
        refreshColdLeadsList: false,
      };
    case NewLeadsMap.GET_ALL_NEW_LEADS_ERROR:
      return {
        ...state,
        isLoading: false,
        refreshColdLeadsList: false,
      };
    case NewLeadsMap.SEARCH_TEXT_CHANGE:
      return {
        ...state,
        searchText: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_NEW_LEADS_BATCH_NUMBER:
      return {
        ...state,
        skip: action.payload,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.GET_NEW_LEAD_START:
      return {
        ...state,
        isLoading: true,
      };
    case NewLeadsMap.GET_NEW_LEAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedColdLead: action.payload,
      };
    case NewLeadsMap.GET_NEW_LEAD_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case NewLeadsMap.SET_AUDIO_TYPE:
      return {
        ...state,
        audioType: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_BATCH_FILTER:
      return {
        ...state,
        batchFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_FROM_DATE_FILTER:
      return {
        ...state,
        fromDateFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_TO_DATE_FILTER:
      return {
        ...state,
        toDateFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_LEAD_TYPE:
      return {
        ...state,
        leadType: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_CALL_OUTCOME_FILTER:
      return {
        ...state,
        callOutcomeFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_COMPANY_NAME_FILTER:
      return {
        ...state,
        companyNameFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_CREATED_BY_FILTER:
      return {
        ...state,
        createdByFilter: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.SET_LIMIT:
      return {
        ...state,
        limit: action.payload,
        skip: 0,
        refreshColdLeadsList: true,
      };
    case NewLeadsMap.RESET_REFRESH_FLAG:
      return {
        ...state,
        refreshColdLeadsList: true,
      };
    default:
      return state;
  }
};


